import { render, staticRenderFns } from "./expansion-panel-header-rich.vue?vue&type=template&id=78e8b4e8&"
import script from "./expansion-panel-header-rich.vue?vue&type=script&lang=js&"
export * from "./expansion-panel-header-rich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports